<template>
    <i
        v-if="updateAvailable"
        v-animation="{ cls: 'fa-bounce', gap: 3 }"
        v-tooltip="'Click to update Zyno'"
        class="fa-solid fa-circle-up update-icon text-white"
        @click="doUpdate"
    ></i>
</template>

<script lang="ts" setup>
import { useIdleUpdateNotifier, useUpdateAvailableRef } from '@/shared/helpers/update.helpers';
import { Logger } from '@/shared/services/logger';
import { showWait } from '@signal24/vue-foundation';

const updateAvailable = useUpdateAvailableRef();

function doUpdate() {
    showWait('Reloading Zyno...');
    location.reload();
}

const logger = Logger.createScoped('QABUpdateIcon');
useIdleUpdateNotifier(300_000, () => {
    if (document.querySelector('.vf-modal-wrap')) {
        return logger.info('Update available and idle triggered, but modal is open');
    }

    logger.info('Reloading ZynoSuite for update');
    showWait('Updating ZynoSuite...');
    window.location.reload();
});
</script>
